.list > li:first-child {
    margin-top: 8px;
}

.list > li:last-of-type {
    margin-bottom: 8px;
}
